import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";


const initialState = {
  ...defaultState(
    "settings", { metadata: undefined, },
    []
  ),
};

const settingEditedSuccess = (state, draft, payload) => {
  const settings = state.settings || [];
  var settingIndex = settings.findIndex((u) => u.id === payload.id);
  draft.settings[settingIndex] = payload;
};



export const reducer = createReducer(initialState, {

  ...bindReducers(ActionTypes, {
    action: "getSettings",
    stateName: "settings",
    async: true,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "editSetting",
    stateName: "setting",
    async: true,
    isPaginated: false,
    successCb: settingEditedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editAllSettings",
    stateName: "settings",
    async: true,
    isPaginated: false,
    // successCb: settingEditedSuccess,
  }),

});
